import { Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie/cjs';
import moment from 'moment';

const cookies = new Cookies();

const columns = [
  {
    title: 'BookingId',
    dataIndex: 'BookingId',
    key: 'BookingId',
  },
  {
    title: 'Previous CarPlate',
    dataIndex: 'previousCarPlate',
    key: 'previousCarPlate',
  },
  {
    title: 'New CarPlate',
    dataIndex: 'newCarPlate',
    key: 'newCarPlate',
  },
  {
    title: 'Action Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'User Type',
    dataIndex: 'userType',
    key: 'userType',
  },
  {
    title: 'User Name/Email',
    dataIndex: 'userName',
    key: 'userName',
  },
  {
    title: 'User ID',
    dataIndex: 'userId',
    key: 'userId',
  },
  {
    title: 'Time',
    dataIndex: 'actionTime',
    key: 'actionTime',
  },
];

function camelCase(str) {
  return str
    .replace(/^(\w)/, (m) => m.toUpperCase())
    .replace(/(-\w)/g, (m) => m[1].toUpperCase())
    .replace(/([A-Z])/g, ' $1');
}

export default function ChangeLog({ showChangeLpnModal, setShowChangeLpnModal }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  async function fetchData() {
    try {
      setLoading(true);
      const {
        data: { data: actionLogData },
      } = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/CarPlateChangeAction`, {
        headers: { token: cookies.get('token') },
        params: { LastBookingId: showChangeLpnModal.id },
      });

      const cleanedData = actionLogData.map((item) => ({
        ...item,
        actionTime: moment(item.actionTime).format('YYYY-MM-DD HH:mm'),
        newCarPlate: item?.metadata?.newCarPlate || '',
        previousCarPlate: item?.metadata?.previousCarPlate || '',
        type: camelCase(item.type),
        userName: item?.User
          ? `${item.User?.username || ''}${item?.User?.phone ? `(${item?.User?.phone})` : ''}\n${
              item.User?.email || ''
            }`
          : '',
        userId: item?.UserId || '',
      }));

      setData(cleanedData);
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!showChangeLpnModal.open || !showChangeLpnModal.id) {
      setData([]);
      setLoading(false);
      return;
    }
    fetchData();
  }, [showChangeLpnModal.open, showChangeLpnModal.id]);

  return (
    <Modal
      footer={null}
      visible={showChangeLpnModal.open}
      onCancel={() => {
        setShowChangeLpnModal({ open: false, id: '' });
      }}
      width={1000}
      title={`LPN Change Log for Booking ${showChangeLpnModal.id}`}
    >
      <Table loading={loading} dataSource={data} columns={columns} pagination={false} />
    </Modal>
  );
}
